var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReservationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 11.9166C7.93841 11.9166 9.16675 10.6883 9.16675 9.16662C9.16675 7.64495 7.93841 6.41662 6.41675 6.41662C4.89508 6.41662 3.66675 7.64495 3.66675 9.16662C3.66675 10.6883 4.89508 11.9166 6.41675 11.9166ZM17.4167 6.41662H11.9167C10.9084 6.41662 10.0834 7.24162 10.0834 8.24995V12.8333H2.75008V5.49995C2.75008 4.99578 2.33758 4.58328 1.83341 4.58328C1.32925 4.58328 0.916748 4.99578 0.916748 5.49995V17.4166C0.916748 17.9208 1.32925 18.3333 1.83341 18.3333C2.33758 18.3333 2.75008 17.9208 2.75008 17.4166V15.5833H19.2501V17.4166C19.2501 17.9208 19.6626 18.3333 20.1667 18.3333C20.6709 18.3333 21.0834 17.9208 21.0834 17.4166V10.0833C21.0834 8.05745 19.4426 6.41662 17.4167 6.41662Z",
    fill: "#4A4A4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationIcon);
export default __webpack_public_path__ + "static/media/reservationIcon.a65c7f046b1cdf237f0719f2ba111591.svg";
export { ForwardRef as ReactComponent };